import { Property } from '@propertypal/shared/src/types/property';
import { PropertySearchResult } from '@propertypal/shared/src/types/propertySearch';
import platform from '@propertypal/shared/src/utils/platform';
import React, { FunctionComponent } from 'react';
import OldPropertyBox from './OldPropertyBox';
import PremierBox from './PremierBox';
import PropertyBox from './PropertyBox';
import { Container, HiddenContainer, HiddenAddress } from './PropertyBox.style';
import PropertyHide from './PropertyHide';

export interface Props {
  property: Property;
  onFavourite?: () => (favourited: boolean, propertyId: number) => Promise<boolean>;
  onHideToggle?: () => (hidden: boolean, propertyId: number) => Promise<boolean>;
  onEmailClick?: (property: Property) => void;
  onCallClick?: (property: Property) => void;
  locationDetail?: PropertySearchResult['locationDetail'];
  imageLocator?: string;
  thumbImageLocator?: string;
  useSlider?: boolean;
  loading?: 'lazy' | 'eager';
  onClick?: () => void;
  showOpenViewingLabel?: boolean;
  useWideDisplay?: boolean;
  showAuctionsLabel?: boolean;
  disablePremiumProperties?: boolean;
  hideFooter?: boolean;
  showThumbs?: boolean;
}

const SearchPropertyBox: FunctionComponent<Props> = (props) => {
  const isPremium = props.property.premiumListing && !props.showOpenViewingLabel;
  const canHide = props.onHideToggle && props.property.type === 'property';

  if (platform.type === 'propertypal' && !process?.env?.JEST_WORKER_ID) {
    return <OldPropertyBox {...props} />;
  }

  if (canHide && props.property.hidden) {
    return (
      <Container
        className="pp-property-box pp-property-box-hidden"
        $useWideDisplay={props.useWideDisplay}
        data-testid="property-box-hidden"
      >
        <HiddenContainer $useWideDisplay={props.useWideDisplay}>
          <HiddenAddress>{props.property.displayAddress}</HiddenAddress>
          <PropertyHide
            hidden={props.property.hidden}
            onHideToggle={(hidden) => props.onHideToggle!()(hidden, props.property.id)}
            key={`hidden-${props.property.id}`}
            button
          />
        </HiddenContainer>
      </Container>
    );
  }

  if (isPremium && !props.disablePremiumProperties) {
    return <PremierBox {...props} platform={platform.type} />;
  }

  return <PropertyBox {...props} useEnhancedBranding={!props.disablePremiumProperties} showThumbs={props.showThumbs} />;
};

export default SearchPropertyBox;
